import type { LocationAssetsListTableProps } from "./location-assets-list-table.type";

import AssetsTable from "@/components/ListTable/AssetsTable";
import AssetAddButton from "@/modules/asset/asset-add-button";

const LocationAssetsListTable = ({
  location,
  loading,
}: LocationAssetsListTableProps) => {
  return (
    <AssetsTable
      extraActions={
        <AssetAddButton
          ancestors={location?.ancestors}
          defaultCoordinate={location?.coordinate}
          shortButtonText
          loading={loading}
        />
      }
    />
  );
};

export default LocationAssetsListTable;
